import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@karma/components';
import { MailIconFilled } from '@karma/components/icons';
import { getUserEmail } from 'store/user/selectors';
import { oldApiInstance } from 'functions/request';
import * as ALOOMA from 'consts/alooma';
import Alooma from 'services/alooma';

const ModalBodyPaypalConfirm = ({ closeModal }) => {
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const email = useSelector(getUserEmail);

  useEffect(() => {
    oldApiInstance.post('/plus/resend_paypal_confirmation_email');
  }, []);

  return (
    <Stack direction="column" spacing={20}>
      <MailIconFilled width={60} height={60} />
      <Stack direction="column" spacing={8}>
        <Typography variant="h3">{t('app:weSentYouEmail')}</Typography>
        <Typography variant="paragraphLarge">
          {t('app:weHaveSentAnEmailTo')} {email}
          <br />
          {t('app:pleaseVerifyYourAccount')}
        </Typography>
      </Stack>
      <Button
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.GOT_IT}
        size="medium"
        onClick={closeModal}
        fullWidth
      >
        {t('app:gotIt')}
      </Button>
    </Stack>
  );
};

export default ModalBodyPaypalConfirm;
